import React, { useContext } from "react";
import { Drawer, Button } from "antd";
import GlobalFilterSidebar from "../GlobalFilterSidebar";
import { usePreference } from "../../context/PreferenceContext";

const HomeFilterDrawer = ({
    open,
    onClose,
    onReset,
    filters,
    onFilterChange,
    categories,
    brands
}) => {
    const { t } = usePreference();

    return (
        <Drawer
            title={
                <div className="pcu-flex pcu-justify-between pcu-flex-center-y pcu-color-title">
                    <span className="pcu-font-700">{t('filters')}</span>
                    <Button type="link" onClick={onReset} size="small" className="pcu-color-orange">{t('reset_all')}</Button>
                </div>
            }
            placement="left"
            onClose={onClose}
            open={open}
            width={320}
            className="custom-drawer"
            styles={{ body: { padding: 0 } }}
            footer={
                <div className="pcu-padding-x-16 pcu-padding-y-12">
                    <Button type="primary" onClick={onClose} block size="large" className="pcu-bg-orange pcu-border-none">
                        {t('apply')}
                    </Button>
                </div>
            }
        >
            <div className="pcu-padding-16">
                <GlobalFilterSidebar
                    filters={filters}
                    onFilterChange={onFilterChange}
                    onReset={() => { onReset(); onClose(); }}
                    categories={categories}
                    brands={brands}
                    config={{
                        showSearch: true,
                        showZipcode: true,
                        showCategories: true,
                        showBrands: true,
                        showRating: true,
                        showPriceRange: false,
                    }}
                    labels={{
                        title: "", // Hide title inside sidebar since Drawer has header
                        resetAll: "",
                        search: t('search'),
                        searchPlaceholder: t('shop_name'),
                        zipcode: t('zipcode'),
                        zipcodePlaceholder: t('zipcode'),
                        categories: t('categories'),
                        brands: t('brands'),
                        rating: t('rating'),
                    }}
                    style={{ boxShadow: 'none', padding: 0 }}
                    className="pcu-shadow-none pcu-padding-0"
                />
            </div>
        </Drawer>
    );
};

export default HomeFilterDrawer;
